// extracted by mini-css-extract-plugin
export default {"Blankslate":"archive-empty-states-module__Blankslate__XnfxZMl","Octicon":"archive-empty-states-module__Octicon__a6jclEw"};